// extracted by mini-css-extract-plugin
export default {"selfBookingHeadline":"SelfBooking_selfBookingHeadline__oBp5r","bookHotelGrid":"SelfBooking_bookHotelGrid__EheS0"};